import React from 'react';
import TextWithIcon from '../components/TextWithIcon';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import renderHighlight from '../utils/search/renderHighlight';
import type { TopicPrivacyIconProps } from './TopicPrivacyIcon';
import { getTopicPrivacyIcon } from './TopicPrivacyIcon';

const TOPIC_FRAGMENT = gql(`
  fragment TopicNameWithIcon_topic on TopicFields {
    id
    name
    ...getTopicPrivacyIcon_topic
  }
`);

type TopicNameWithIconProps = {
  topic: DocumentType<typeof TOPIC_FRAGMENT>;
} & Pick<TopicPrivacyIconProps, 'iconSize' | 'showDefaultIcon' | 'tooltip'> &
  (
    | {
        truncate: true;
        highlighted?: never;
        name?: string;
      }
    | {
        highlighted?: boolean;
        truncate?: never;
        name?: React.ReactNode;
      }
  );

const TopicNameWithIcon = React.forwardRef<
  HTMLDivElement,
  TopicNameWithIconProps
>(
  (
    { highlighted, name, topic, truncate, iconSize, showDefaultIcon, tooltip },
    ref,
  ) => {
    if (truncate) {
      return (
        <TextWithIcon
          text={name ?? topic.name}
          icon={getTopicPrivacyIcon({
            topic,
            tooltip,
            iconSize,
            showDefaultIcon,
          })}
          truncate={truncate}
          ref={ref}
        />
      );
    }

    let text: React.ReactNode = topic.name;
    if (name) {
      text =
        highlighted && typeof name === 'string' ? renderHighlight(name) : name;
    }

    return (
      <TextWithIcon
        text={text}
        icon={getTopicPrivacyIcon({
          topic,
          tooltip,
          iconSize,
          showDefaultIcon,
        })}
        ref={ref}
      />
    );
  },
);

export default TopicNameWithIcon;
